import { render, staticRenderFns } from "./PopoverPreviewRemarkComponent.vue?vue&type=template&id=001b7cee&scoped=true"
import script from "./PopoverPreviewRemarkComponent.vue?vue&type=script&lang=js"
export * from "./PopoverPreviewRemarkComponent.vue?vue&type=script&lang=js"
import style0 from "./PopoverPreviewRemarkComponent.vue?vue&type=style&index=0&id=001b7cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b7cee",
  null
  
)

export default component.exports